"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payPalWebsite = void 0;
const payPalWebsites = {
    SANDBOX: 'https://sandbox.paypal.com',
    PRODUCTION: 'https://www.paypal.com',
};
const payPalWebsite = (isSandbox) => payPalWebsites[isSandbox ? 'SANDBOX' : 'PRODUCTION'];
exports.payPalWebsite = payPalWebsite;
//# sourceMappingURL=config.js.map